<template>
  <el-row>
    <el-col class="chart-content">
      <indicador-por-meta></indicador-por-meta>
    </el-col>
    <el-col class="chart-content">
      <el-card>
        <indicador-por-meta-periodo></indicador-por-meta-periodo>
      </el-card>
    </el-col>
    <el-col class="chart-content">
      <el-card>
        <linhas-por-coluna></linhas-por-coluna>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
  import FilterGraph from '../FilterGraph'
  import IndicadorPorMeta from './Graficos/IndicadorPorMeta'
  import IndicadorPorMetaPeriodo from './Graficos/IndicadorPorMetaPeriodo'
  import LinhasPorColuna from './Graficos/LinhasPorColuna'
  import LinhasPorColunaFilter from './Graficos/LinhasPorColunaFilter'

  export default {
    name: "index",
    components: {IndicadorPorMeta, IndicadorPorMetaPeriodo, FilterGraph, LinhasPorColuna, LinhasPorColunaFilter},
    data() {
      return {
        liberado: false
      }
    }
  }
</script>

<style scoped>
  .chart-content {
    padding-bottom: 1em;
  }
</style>



// WEBPACK FOOTER //
// src/features/Dashboard/Components/Home/index.vue